import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GeoLocationService as SitewideGeoLocationService } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { formatErrorCode } from '../../adapters/utils/utils.adapter';
import { BOOK_WIDGET_ERROR_CODES } from '../../constants/error-codes.constants';
import { FlightShopWidgetTemplates } from '../../constants/flight-shop.constants';
import { GeoLocationResponse } from '../../models/core-apis/geo-location.interfaces';
import { GeoLocationService } from '../../services/geo-location.service';
import * as fromErrorHandlerActions from '../actions/error-handler.actions';
import * as fromGeoLocationActions from '../actions/geo-location.actions';
import { getFlightShopTemplateType } from '../selectors/book-widget.selectors';
import { shouldTriggerGeoLocationApi } from '../selectors/geo-location.selectors';

@Injectable({ providedIn: 'root' })
export class GeoLocationEffects {
  loadGeoLocation$ = createEffect(
    (): Observable<Action> =>
      this.GeoLocationActions$.pipe(
        ofType(fromGeoLocationActions.LoadGeoLocation),
        concatLatestFrom(() => [
          this.store.select(shouldTriggerGeoLocationApi),
          this.store.select(getFlightShopTemplateType)
        ]),
        filter(
          ([, shouldTriggerGeoLocationApiValue]) =>
            shouldTriggerGeoLocationApiValue
        ),
        switchMap(([, , flightShopTemplateType]) => {
          const serviceObservable =
            flightShopTemplateType === FlightShopWidgetTemplates.HOME
              ? this.sitewideGeoLocationService.getClosestAirportCode$()
              : this.service.getGeoLocation();

          return serviceObservable.pipe(
            map((geoLocationResponse: GeoLocationResponse) =>
              fromGeoLocationActions.LoadGeoLocationSuccess({
                geoLocationData: geoLocationResponse
              })
            ),
            catchError((error: HttpErrorResponse) => {
              return of(
                fromErrorHandlerActions.HandleError({
                  errorCode: formatErrorCode(
                    BOOK_WIDGET_ERROR_CODES.GEO_LOCATION_FAILURE,
                    error?.status
                  ),
                  error: BOOK_WIDGET_ERROR_CODES.GEO_LOCATION_FAILURE
                }),
                fromGeoLocationActions.LoadGeoLocationFailure()
              );
            })
          );
        })
      )
  );

  constructor(
    private GeoLocationActions$: Actions,
    private service: GeoLocationService,
    private store: Store,
    private sitewideGeoLocationService: SitewideGeoLocationService
  ) {}
}
